import React from 'react';
import './NavBar.css';

const Logo = () => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 2923.99 2674.78"
    className="logo-svg"
  >
    <defs>
      <style>
        {`
          .cls-1 { fill: url(#Gradiente_sem_nome_6-3); }
          .cls-2 { fill: #fff; }
          .cls-3 { fill: url(#Gradiente_sem_nome_6-4); }
          .cls-4 { fill: url(#Gradiente_sem_nome_6-2); }
          .cls-5 { fill: url(#Gradiente_sem_nome_6); }
        `}
      </style>
      <linearGradient
        id="Gradiente_sem_nome_6"
        x1="2673.63"
        y1="-2.48"
        x2="2673.63"
        y2="53.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".15" stopColor="#005321" />
        <stop offset=".55" stopColor="#ffed00" />
        <stop offset=".95" stopColor="#005321" />
      </linearGradient>
      <linearGradient
        id="Gradiente_sem_nome_6-2"
        x1="2537.29"
        y1="522.51"
        x2="495.15"
        y2="526.31"
        xlinkHref="#Gradiente_sem_nome_6"
      />
      <linearGradient
        id="Gradiente_sem_nome_6-3"
        x1="211.78"
        y1="2649.62"
        x2="234.45"
        y2="2649.62"
        xlinkHref="#Gradiente_sem_nome_6"
      />
      <linearGradient
        id="Gradiente_sem_nome_6-4"
        x1="234.45"
        y1="2186.41"
        x2="2506.11"
        y2="2186.41"
        xlinkHref="#Gradiente_sem_nome_6"
      />
    </defs>
    <g id="Camada_1">
      <path
        className="cls-2"
        d="M597.04,999.24c141.29-338.6,475.74-577.23,864.95-577.23s723.65,238.63,864.94,577.23h189.72c-149.96-438.58-565.92-754.94-1054.66-754.94S557.28,560.66,407.32,999.24h189.72Z"
      />
      <path
        className="cls-2"
        d="M2313.64,1748.38c-148.15,322.58-474.05,547.26-851.65,547.26s-703.51-224.68-851.65-547.26h-192.48c158.33,422.98,566.57,724.97,1044.13,724.97s885.79-301.99,1044.12-724.97h-192.47Z"
      />
      <path
        className="cls-2"
        d="M188.53,1062.78v330.28h377.42v153.28H0v-483.56h188.53Z"
      />
      <path
        className="cls-2"
        d="M1326.9,1063.5h212.28l-212.28,483.56h-224.15l-106.13-241.77-106.14,241.77h-224.15l-212.27-483.56h212.27l111.9,306.18,112.26-306.18h212.27l111.9,306.18,112.26-306.18Z"
      />
      <path
        className="cls-2"
        d="M1983.87,1063.5c132.76-1.8,231.34,109.74,230.27,241.78,1.07,131.32-97.51,243.58-230.27,241.77h-430.31v-483.56h430.31ZM1948.6,1216.77h-206.51v177.02h206.51c48.93,0,76.63-39.94,76.63-88.51s-27.7-88.51-76.63-88.51Z"
      />
      <path
        className="cls-2"
        d="M2923.99,1345.93c-11.87,163.35-155.07,212.28-329.21,212.28-181.34-.36-331.01-52.89-330.28-236.02v-35.26c-.73-182.77,148.95-235.3,330.28-236.02,174.14.36,317.34,49.29,329.21,212.28h-193.21c-17.64-47.49-71.25-58.65-136.01-58.65-76.99,1.08-142.48,14.75-141.4,94.27v11.87c-1.08,78.79,64.41,93.19,141.4,94.26,64.76,0,118.74-11.51,136.01-59.01h193.21Z"
      />
      <path
        className="cls-5"
        d="M2662.52,49.37c17.77-29.15,22.23-49.37,22.23-49.37,0,0-7.07,18.63-22.23,49.37Z"
      />
      <path
        className="cls-4"
        d="M483.43,999.24c138.15-258.67,411.5-523.99,941.71-401.81,807.6,186.1,1151.93-374.78,1237.38-548.05-61.28,100.49-281.39,307.33-1027.47,159.65C807.07,86.2,512.28,606.09,407.32,999.24h76.11Z"
      />
      <path
        className="cls-1"
        d="M234.45,2624.45c-18.12,29.72-22.66,50.34-22.66,50.34,0,0,7.21-18.99,22.66-50.34Z"
      />
      <path
        className="cls-3"
        d="M2400.69,1748.38c-154.39,229.33-427.47,427.26-904.67,317.3-823.4-189.74-1174.46,382.11-1261.58,558.77,62.48-102.45,286.89-313.34,1047.56-162.78,780.62,115.8,1096.36-328.74,1224.1-713.29h-105.42Z"
      />
    </g>
  </svg>
);

export default Logo;
